import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=099bec33&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=099bec33&prod&scoped=true&lang=css"
import style1 from "./Message.vue?vue&type=style&index=1&id=099bec33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099bec33",
  null
  
)

export default component.exports